import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from "angular-notifier";
import { SettingsModel, SettingsService } from "@bt/core";
import {faSave} from '@fortawesome/free-solid-svg-icons';
import { FormGroup, FormBuilder, Validators, FormsModule,FormArray,AbstractControl, FormControl } from "@angular/forms";


@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent extends BaseComponent implements OnInit {

  faSave = faSave;

  public settings: any[];
  notifier: any;
  public isResponsed: boolean = false;
  public validForm: FormGroup;

  constructor(
    private settingsService: SettingsService,
    notifierService: NotifierService,
    private fb: FormBuilder,
  ) {
    super();
    this.notifier = notifierService;
    
   }

  ngOnInit() {

    this.validForm = this.fb.group({
      validSettings :this.fb.array([]),
    });

    this.GetSettings();
  }

  get validSettings() { return this.validForm.controls.validSettings; }

  public settingI(i:number) :AbstractControl {
    return (<any>this).validSettings.controls[i].controls.value;
  }

  GetSettings(){
    this.setLoading(true);
    this.settingsService.GetSettings()
    .then((resp) => {
      this.settings = resp.data;
      //this.hasInfo = resp.data.length != 0;

      const contrSetting = this.validForm.controls.validSettings as FormArray;
      this.settings.forEach(x=>{
        contrSetting.push(this.fb.group({
          // key: x.key,
          value:  [x.value, [Validators.required, Validators.min(0), Validators.max(100)]],
        }));
      });



      this.isResponsed = true;
      this.setLoading(false);
    })
    .catch((error)=>{
      
      this.notifier.notify('error', "Ошибка при получении списка настроек");
      //this.hasInfo = false;
      this.isResponsed = false;
      this.setLoading(false);
    });

  }

  SetSettings(){
    this.setLoading(true);
    if (!this.validForm.valid) {
      this.setLoading(false);
      this.notifier.notify('error', "Проверьте корректность данных");
      this.markFormGroupTouchedAndDirty(this.validForm);
      return;
    }

    this.setLoading(true);
    this.settingsService.SaveSettings(this.settings)
    .then((resp) => {
      this.notifier.notify('success', "Успешно сохранено");
      this.setLoading(false);
    })
    .catch((responce)=>{
      var text = this.GetErrorMessageText("Не удалось сохранить данные домена", responce);
      this.notifier.notify('error', text);

      this.setLoading(false);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/settings/settings.component.ts